<template>
	<div>
		<el-table :data="teacher_list" border size="mini">
			<el-table-column prop="create_time" align="center" :label="$t('virtual.time')" data-nam="时间">
				<template slot-scope="scope"> {{getTime_us(scope.row.create_time,'mmddyyyy')}} {{getTime_us(scope.row.create_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="name" align="center" :label="$t('virtual.feedback_name')" data-name="用户"></el-table-column>
			<el-table-column prop="content" align="center" :label="$t('virtual.content')" data-name="内容"></el-table-column>
			<el-table-column prop="reply" align="center" :label="$t('virtual.reply')" data-name="回复"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="huife_f(scope.row)" data-name="回复">{{$t('virtual.reply')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('virtual.reply')" width="400px" :close-on-click-modal="false" :append-to-body="true" :visible="huife" @close="huife = false">
			<el-form :model="editForm" size="mini" label-position="top" :rules="editFormRules" ref="editForm">
				<el-col :span="24">
					<el-form-item :label="$t('virtual.reply')" prop="reply">
						<el-input v-model="editForm.reply" placeholder="" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="huife = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="virtualOpinionReplyAction('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed: {
		editFormRules() {
			return {
				reply: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('virtual.reply'),
					trigger: 'change'
				}],
			}
		},
	},
	props:{
		type: {
			type: String,
			default:''
		},
		course_id: {
			type: String,
			default:''
		},
		course_type: {
			type: String,
			default:''
		},
	},
	data() {
		return {
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			teacher_list:[],
			huife:false,
			editForm:{
				reply:'',
			},
		}
	},
	watch: {
		type(v){
			if (v=='feedback') {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		init(){
			var this_ = this;
			var url = "userCourseOpinionList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.teacher_list = res.list;
				this_.pages.count = res.sum;
			})
		},
		virtualOpinionReplyAction(){
			var this_ = this;
			var url = "virtualOpinionReplyAction";
			var datas = {
				id:this_.editForm.id,
				reply:this_.editForm.reply,
			};
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.huife = false;
						this_.init();
					})
				}
			})
		},
		huife_f(data){
			this.editForm=JSON.parse(JSON.stringify(data));
			this.huife=true;	
		},
		guanbi(){
			this.$emit("guanbitanchu");
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.page-pagination{
	padding: 20px 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue